var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.442 4.5a.305.305 0 0 1 .301.254l1.855 10.902a1.806 1.806 0 0 0 1.78 1.503h6.978a.75.75 0 0 0 0-1.5H9.378a.305.305 0 0 1-.301-.254L7.222 4.502A1.806 1.806 0 0 0 5.442 3H4.75a.75.75 0 0 0 0 1.5h.692ZM9.762 18.473a1.014 1.014 0 1 1 0 2.027 1.014 1.014 0 0 1 0-2.027ZM15.168 18.473a1.014 1.014 0 1 1 0 2.027 1.014 1.014 0 0 1 0-2.027Z",
    fill: "#017C6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.71 7.66H6.872a.75.75 0 0 1 0-1.5h12.122a1.278 1.278 0 0 1 1.24 1.587l-1.02 4.08a2.86 2.86 0 0 1-2.774 2.166H7.948a.75.75 0 0 1 0-1.5h8.49a1.361 1.361 0 0 0 1.32-1.03l.95-3.803Z",
    fill: "#017C6B"
  })));
};
export default SvgCart;